import {produce} from 'immer';
import {useAtom} from 'jotai';
import {useRef, useState} from 'react';
import styled from 'styled-components';
import {getCategoryIcon} from '@/components/CategoryIcon';
import {MYFC_CATEGORIES} from '@/constants';
import {useBackgroundClick} from '@/hooks';
import {useGA4WithParams} from '@/hooks/tracking';
import {NearbyOptionItem} from '@/map/@types';
import {nearbyStoreCategoryAtom} from '@/map/atom';
import {getCategoryId} from '@/utils';
import {ToolboxItemProps} from '../';
import {ReactComponent as MenuIcon} from '../assets/near-franchise.svg';
import {ToolboxItem} from '../StyledComponents';
import {SelectInfoWindow} from './SelectInfoWindow';

const REPLACE_LABEL_PAIR: any = {
  '별식·퓨전요리': '별식 퓨전',
  '스터디카페·독서실': '스터디카페',
};

const replaceLabel = (origin: string) => REPLACE_LABEL_PAIR[origin] ?? origin;

const options: NearbyOptionItem[] = MYFC_CATEGORIES.map((i) => ({
  id: i,
  label: replaceLabel(i),
  icon: getCategoryIcon(getCategoryId(i), 22),
}));

export const NearbyCategoryButton = (props: ToolboxItemProps) => {
  const [nearbyData, setNearby] = useAtom(nearbyStoreCategoryAtom);
  const [open, setOpen] = useState<boolean>(false);

  const selected = nearbyData.selected;
  const active = open || nearbyData.active;

  const menuRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useBackgroundClick(menuRef, () => setOpen((prev) => !prev), [buttonRef]);

  const tracking = useGA4WithParams();

  const onSelected = (nextSelected: string[]) => {
    setNearby(
      produce((draft) => {
        draft.selected = nextSelected as any;
      })
    );
    tracking('nearby_franchise', {
      nearby_franchise_array: nextSelected,
    });
  };

  const handleSwitch = (nextActive: boolean) => {
    setNearby(
      produce((draft) => {
        draft.active = nextActive;
      })
    );
  };

  return (
    <Root>
      <ToolboxItem
        {...props}
        ref={buttonRef}
        active={active}
        onClick={() => setOpen((prev) => !prev)}
      >
        <MenuIcon />
      </ToolboxItem>
      {open && (
        <SelectInfoWindow
          title="주변 프랜차이즈"
          type="업종"
          limit={6}
          active={nearbyData.active}
          ref={menuRef}
          options={options}
          selected={selected}
          onSelected={onSelected}
          onSwitchChanged={handleSwitch}
        />
      )}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
`;
